import packageJson from '../package.json';

export const AZURE_AD = {
  clientId: import.meta.env.VITE_AZURE_AD_CLIENT_ID,
  tenantId: import.meta.env.VITE_AZURE_AD_TENANT_ID,
  authority: import.meta.env.VITE_AZURE_AD_AUTHORITY,
};

export const BACKEND_API = {
  baseUrl: import.meta.env.VITE_API_BASE_URL,
  prefix: import.meta.env.VITE_API_PREFIX,
};

export const APPLICATION_ID = 'halo-ai-studio';

export const STORAGE_BASE = `s3://podium-ia-call-summarization-app-documents-${process.env.ENTERPRISE_NAME}-${process.env.NODE_ENV}`;

export const FEATURE_FLAGS = {
  enableFileUpload: import.meta.env.VITE_ENABLE_FILE_UPLOAD,
  enableS3Integration: import.meta.env.VITE_ENABLE_S3_INTEGRATION,
  enableKnowledgeBase: import.meta.env.VITE_ENABLE_KNOWLEDGE_BASE,
};

export const CONFIG = {
  appVersion: packageJson.version,
  assetsDir: '',
  auth: {
    method: 'msal',
    redirectPath: '/',
  },
};
